var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-date-picker',{attrs:{"label":"Date","validation-errors":_vm.validationErrors.deal_at,"is-inline":""},model:{value:(_vm.form.deal_at),callback:function ($$v) {_vm.$set(_vm.form, "deal_at", $$v)},expression:"form.deal_at"}})
}
var staticRenderFns = []

export { render, staticRenderFns }